/**
 * bahtText — convert a number to Thai baht text (e.g. 1070.5 → "หนึ่งพันเจ็ดสิบบาทห้าสิบสตางค์").
 * Used on the full-form tax invoice, where the amount in words is expected.
 */

const DIGITS = ['', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า'];
const UNITS = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน'];

// Read an integer < 1,000,000 into Thai words.
function readBelowMillion(n) {
  n = Math.floor(n);
  if (n === 0) return '';
  const s = String(n);
  const len = s.length;
  let result = '';
  for (let i = 0; i < len; i++) {
    const digit = parseInt(s[i], 10);
    const pos = len - i - 1; // 0 = units, 1 = tens, ...
    if (digit === 0) continue;
    if (pos === 0 && digit === 1 && len > 1) {
      result += 'เอ็ด';
    } else if (pos === 1 && digit === 1) {
      result += 'สิบ';
    } else if (pos === 1 && digit === 2) {
      result += 'ยี่สิบ';
    } else {
      result += DIGITS[digit] + UNITS[pos];
    }
  }
  return result;
}

// Read any non-negative integer, chaining millions ("ล้าน").
function readInteger(n) {
  n = Math.floor(n);
  if (n === 0) return 'ศูนย์';
  let result = '';
  let scale = 0;
  while (n > 0) {
    const chunk = n % 1000000;
    n = Math.floor(n / 1000000);
    if (chunk !== 0) {
      const suffix = 'ล้าน'.repeat(scale);
      result = readBelowMillion(chunk) + suffix + result;
    }
    scale += 1;
  }
  return result;
}

export function bahtText(value) {
  let num = parseFloat(value);
  if (!Number.isFinite(num)) num = 0;
  const negative = num < 0;
  num = Math.abs(num);
  num = Math.round(num * 100) / 100;

  const baht = Math.floor(num);
  const satang = Math.round((num - baht) * 100);

  let text = readInteger(baht) + 'บาท';
  if (satang === 0) {
    text += 'ถ้วน';
  } else {
    text += readInteger(satang) + 'สตางค์';
  }
  return (negative ? 'ลบ' : '') + text;
}

export default bahtText;
